/* eslint-disable import/prefer-default-export */
const portalStyles = {
  inlinePortalZIndexIncrement: 10000
};

export { portalStyles as p };
//# sourceMappingURL=portal-DhH1e5-Z.js.map
